// extracted by mini-css-extract-plugin
export default {"container":"AngloAmericanIct_container__KyDZ2","heading":"AngloAmericanIct_heading__wDCTH","date":"AngloAmericanIct_date__cqL4p","content":"AngloAmericanIct_content__a9xby"};